module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post-form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendForm($event)
      }
    }
  }, [_c('ui-field-group', {
    attrs: {
      "help": _vm.$t('modules.posts.help.created_at')
    }
  }, [_c('ui-text', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.created_at),
      expression: "created_at"
    }],
    attrs: {
      "name": "created_at",
      "required": ""
    },
    domProps: {
      "value": (_vm.created_at)
    },
    on: {
      "input": function($event) {
        _vm.created_at = $event
      }
    }
  }), _vm._v(" "), _c('ui-label', [_vm._v(_vm._s(_vm.$t('modules.posts.fields.created_at')))])], 1), _vm._v(" "), _c('ui-field-group', {
    attrs: {
      "help": _vm.$t('modules.posts.help.title')
    }
  }, [_c('ui-text', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    attrs: {
      "name": "title",
      "required": ""
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        _vm.title = $event
      }
    }
  }), _vm._v(" "), _c('ui-label', [_vm._v(_vm._s(_vm.$t('modules.posts.fields.title')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--6-col"
  }, [_c('ui-field-group', {
    attrs: {
      "help": _vm.$t('modules.posts.help.body')
    }
  }, [_c('ui-text-area', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body),
      expression: "body"
    }],
    attrs: {
      "name": "body",
      "required": ""
    },
    domProps: {
      "value": (_vm.body)
    },
    on: {
      "input": function($event) {
        _vm.body = $event
      }
    }
  }), _vm._v(" "), _c('ui-label', [_vm._v(_vm._s(_vm.$t('modules.posts.fields.body')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--6-col"
  }, [_c('small', [_vm._v("Preview")]), _vm._v(" "), _c('div', {
    staticClass: "markdown-preview",
    domProps: {
      "innerHTML": _vm._s(_vm.compiledMarkdown)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "submit-box"
  }, [_c('ui-button', {
    attrs: {
      "disabled": _vm.sending,
      "spinner": "",
      "type": "submit",
      "raised": "",
      "primary": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.save')) + "\n      ")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14df16d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modules/Post/PostForm.vue
// module id = 262
// module chunks = 2